import { render, staticRenderFns } from "./changePwdDialog.vue?vue&type=template&id=5162765a&scoped=true"
import script from "./changePwdDialog.vue?vue&type=script&lang=js"
export * from "./changePwdDialog.vue?vue&type=script&lang=js"
import style0 from "./changePwdDialog.vue?vue&type=style&index=0&id=5162765a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5162765a",
  null
  
)

export default component.exports